import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.dantsri.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const Seo = ({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  keywords,
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | DantSri Dental Clinic` : 'DantSri Dental Clinic';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:site_name" content="DantSri Dental Clinic" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical || SITE_URL} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
};

export default Seo;
